import { request } from "../../../services/apiClient";

export interface PublicLotVertex {
  latitude: number;
  longitude: number;
}

export interface PublicLotSegment {
  distance_m: number;
  is_tie: boolean;
  seq_no: number;
}

export interface PublicLot {
  id: string;
  title: string;
  status: string;
  area_sqm?: number;
  property_type?: string;
  region?: string | null;
  province?: string | null;
  municipality?: string | null;
  barangay?: string | null;
  vertices: PublicLotVertex[];
  segments: PublicLotSegment[];
  updated_at: string;
}

export async function getPublicLot(id: string): Promise<PublicLot> {
  // Public endpoint: avoid passing stale tokens so expired sessions don't trigger 401.
  return request<PublicLot>(`/public/lots/${id}`);
}
